export default __webpack_public_path__ + "static/supercoach-948c353ca3cb54033de12ad61f0291e7.svg";